// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1Ro-a","inner":"Footer_inner__eY-XV"};